// extracted by mini-css-extract-plugin
module.exports = {"cancellation-policy":"cancellation-policy__29K7B","header":"header__2rUwJ","body":"body__1ipnM","supplement":"supplement__2Mvad","link":"link__21hLZ","red":"red__2G2wn"};